export * from './deprecated-events-definition'
import * as NEWPropertyEvents from './events-definition'
export { NEWPropertyEvents }
